import ReduxToolkit, { createSlice } from '@reduxjs/toolkit';

import { CurrencyType } from '@modules/currencies/constants/CurrencyType';
import { GameType } from '@modules/games/Game/constants/availableGames';
import { capitalize } from '@legacyApp/client/modules/app/appService';
import { Bet } from '@modules/games/Game/store/game/@types/PlaceBetResponse';

const NAME = (game: GameType) => `betSummary${capitalize(game)}`;

export type ValueType = {
	currency: CurrencyType;
	profit: number;
	payout: number;
	hash: string;
	bet: Bet;
};

const initialState: ValueType = {
	currency: null,
	profit: null,
	payout: null,
	hash: null,
	bet: null,
};

const setAction: ReduxToolkit.CaseReducer<
	ValueType,
	ReduxToolkit.PayloadAction<ValueType>
> = (state, action) => {
	return !action?.payload ? initialState : action.payload;
};

export const betSummarySlice = (game: GameType) =>
	createSlice({
		name: NAME(game),
		initialState,
		reducers: {
			betSummaryUpdate: setAction,
		},
	});
